var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      !_vm.mobileView
        ? _c("div", [
            _c("div", { attrs: { id: "subheader" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { top: "50vh", height: "90vh" },
                attrs: { id: "main-container" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { height: "82vh" },
                    attrs: { id: "container" }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { id: "list-container" } },
                      _vm._l(_vm.items, function(item) {
                        return _vm.show
                          ? _c("item-pedido", {
                              attrs: { id: "list-prod", item: item },
                              on: { eliminarItem: _vm.btnEliminarItem }
                            })
                          : _vm._e()
                      })
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fv rc",
                        staticStyle: { width: "100%", "margin-top": "10px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Subtotal: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.subtotal)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Descuentos: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.descuentos)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Impuestos: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "11px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(_vm.impuestos)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: { "margin-right": "40px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#5D6770"
                                }
                              },
                              [_vm._v(" Total: ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "fh rc",
                                staticStyle: {
                                  width: "150px",
                                  "font-size": "14px",
                                  color: "#5D6770"
                                }
                              },
                              [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm._f("formatMoney")(
                                        _vm.subtotal -
                                          _vm.descuentos +
                                          _vm.impuestos
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { "margin-top": "5px" },
                        attrs: { id: "btnContainer" }
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "btnEliminar",
                            type: "submit",
                            value: "ELIMINAR"
                          },
                          on: { click: _vm.btnEliminar }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            id: "btnGuardar",
                            type: "submit",
                            value: "GUARDAR"
                          },
                          on: { click: _vm.btnGuardar }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            id: "btnAgregar",
                            type: "submit",
                            value: "AGREGAR"
                          },
                          on: { click: _vm.btnAgregar }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            id: "btnEnviar",
                            type: "submit",
                            value: "ENVIAR"
                          },
                          on: { click: _vm.btnEnviar }
                        })
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "fv ct",
                staticStyle: {
                  width: "100vw",
                  height: "100vh",
                  "margin-top": "40px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "4%",
                      background: "#44C7F4",
                      color: "white",
                      font: "size 12px"
                    }
                  },
                  [_vm._v("Carrito de Compras")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "5%",
                      background: "#eeeeee"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: {
                          width: "33%",
                          height: "100%",
                          "font-size": "14px",
                          color: "#5C666F"
                        }
                      },
                      [
                        _vm._v(
                          "Subtotal: $" +
                            _vm._s(_vm._f("formatMoney")(_vm.subtotal))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: {
                          width: "33%",
                          height: "100%",
                          "font-size": "14px",
                          color: "#5C666F"
                        }
                      },
                      [
                        _vm._v(
                          "Descuentos: -$" +
                            _vm._s(_vm._f("formatMoney")(_vm.descuentos))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: {
                          width: "33%",
                          height: "100%",
                          "font-size": "14px",
                          color: "#5C666F"
                        }
                      },
                      [
                        _vm._v(
                          "Impuestos: $" +
                            _vm._s(_vm._f("formatMoney")(_vm.impuestos))
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      width: "100%",
                      height: "5%",
                      background: "#eeeeee"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fh cc",
                        staticStyle: {
                          width: "100%",
                          height: "5%",
                          "font-size": "18px",
                          "font-weight": "500",
                          color: "#5C666F"
                        }
                      },
                      [
                        _vm._v(
                          "Total: $" +
                            _vm._s(
                              _vm._f("formatMoney")(
                                _vm.subtotal - _vm.descuentos + _vm.impuestos
                              )
                            )
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { height: "55%" },
                    attrs: { id: "list-container" }
                  },
                  _vm._l(_vm.items, function(item) {
                    return _vm.show
                      ? _c("item-pedido", {
                          attrs: { id: "list-prod", item: item },
                          on: { eliminarItem: _vm.btnEliminarItem }
                        })
                      : _vm._e()
                  })
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btnMobile",
                        staticStyle: {
                          background: "white",
                          color: "#ff0000",
                          border: "none"
                        },
                        on: { click: _vm.btnEliminar }
                      },
                      [_vm._v("ELIMINAR")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btnMobile",
                        staticStyle: {
                          background: "white",
                          color: "#4969B2",
                          "border-style": "solid",
                          "border-width": "1px",
                          "border-color": "#4969B2"
                        },
                        on: { click: _vm.btnGuardar }
                      },
                      [_vm._v("GUARDAR")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btnMobile",
                        on: { click: _vm.btnAgregar }
                      },
                      [_vm._v("AGREGAR")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btnMobile",
                        on: { click: _vm.btnEnviar }
                      },
                      [_vm._v("ENVIAR")]
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.mobileView
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "fadePro" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPopup,
                        expression: "showPopup"
                      }
                    ],
                    attrs: { showPopup: _vm.showPopup }
                  },
                  [
                    _c("div", { attrs: { id: "back-popup" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { id: "popup-envio-pedido" } },
                      [
                        _c(
                          "div",
                          { attrs: { id: "popup-btnClose-container" } },
                          [
                            _c("img", {
                              staticStyle: { width: "20px", height: "20px" },
                              attrs: {
                                id: "btnClose",
                                src: "/dist/btnClose.png"
                              },
                              on: { click: _vm.btnCerrarPopup }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: { id: "popup-titulo" }
                          },
                          [_vm._v("Enviar Pedido")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showCondicionVenta,
                                expression: "showCondicionVenta"
                              }
                            ],
                            staticClass: "labels-forms"
                          },
                          [_vm._v("Condición de venta")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.condicionVenta,
                                expression: "condicionVenta"
                              },
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showCondicionVenta,
                                expression: "showCondicionVenta"
                              }
                            ],
                            staticClass: "wc",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.condicionVenta = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.condicionesVenta, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option } },
                              [_vm._v(_vm._s(option.Nombre))]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showCalendar,
                                expression: "showCalendar"
                              }
                            ],
                            staticClass: "labels-forms"
                          },
                          [_vm._v("Fecha de despacho")]
                        ),
                        _vm._v(" "),
                        _c("datepicker", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showCalendar,
                              expression: "showCalendar"
                            }
                          ],
                          attrs: {
                            "wrapper-class": "wc",
                            "input-class": "datepicker-ic",
                            disabledDates: _vm.disabledDates,
                            language: _vm.es
                          },
                          model: {
                            value: _vm.calendario,
                            callback: function($$v) {
                              _vm.calendario = $$v
                            },
                            expression: "calendario"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showSucursal,
                                expression: "showSucursal"
                              }
                            ],
                            staticClass: "labels-forms"
                          },
                          [_vm._v("Sucursal de entrega")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sucursal,
                                expression: "sucursal"
                              },
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showSucursal,
                                expression: "showSucursal"
                              }
                            ],
                            staticClass: "wc",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.sucursal = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.sucursales, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option } },
                              [_vm._v(_vm._s(option.Nombre))]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showEmail,
                                expression: "showEmail"
                              }
                            ],
                            staticClass: "labels-forms"
                          },
                          [_vm._v("Email para envíar el Pedido en PDF")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showEmail,
                              expression: "showEmail"
                            }
                          ],
                          staticStyle: {
                            "text-align": "left",
                            "padding-left": "10px",
                            "margin-left": "30px",
                            "margin-bottom": "20px",
                            width: "336px",
                            height: "30px",
                            "font-size": "14px",
                            "font-weight": "100",
                            "border-radius": "5px",
                            "border-style": "solid"
                          },
                          attrs: { type: "email" },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "labels-forms" }, [
                          _vm._v("Observaciones")
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.observaciones,
                              expression: "observaciones"
                            }
                          ],
                          attrs: { id: "obs" },
                          domProps: { value: _vm.observaciones },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.observaciones = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { attrs: { id: "btnContainerPopup" } }, [
                          _c(
                            "button",
                            {
                              attrs: { id: "btnclose" },
                              on: { click: _vm.btnCerrarPopup }
                            },
                            [_vm._v("CANCELAR")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              attrs: { id: "btnsend" },
                              on: { click: _vm.btnEnviarPopup }
                            },
                            [_vm._v("ENVIAR")]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "fadePro" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPopup,
                        expression: "showPopup"
                      }
                    ],
                    staticClass: "fv lt",
                    attrs: { showPopup: _vm.showPopup }
                  },
                  [
                    _c("div", { attrs: { id: "back-popup" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: { width: "90vw" },
                        attrs: { id: "popup-envio-pedido" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "fh rb",
                            staticStyle: { width: "100%", height: "30px" }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "20px",
                                height: "20px",
                                "margin-right": "15px"
                              },
                              attrs: {
                                id: "btnClose",
                                src: "/dist/btnClose.png"
                              },
                              on: { click: _vm.btnCerrarPopup }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh cc",
                            staticStyle: {
                              height: "60px",
                              "font-size": "18px",
                              color: "#5C666F"
                            }
                          },
                          [_vm._v("Enviar Pedido")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showCondicionVenta,
                                expression: "showCondicionVenta"
                              }
                            ],
                            staticClass: "fh lc",
                            staticStyle: {
                              "margin-left": "5%",
                              height: "10%",
                              "font-size": "12px",
                              color: "#5C666F"
                            }
                          },
                          [_vm._v("Condición de venta")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.condicionVenta,
                                expression: "condicionVenta"
                              },
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showCondicionVenta,
                                expression: "showCondicionVenta"
                              }
                            ],
                            staticClass: "wc-mobile",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.condicionVenta = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.condicionesVenta, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option } },
                              [_vm._v(_vm._s(option.Nombre))]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showCalendar,
                                expression: "showCalendar"
                              }
                            ],
                            staticClass: "fh lc",
                            staticStyle: {
                              "margin-left": "5%",
                              height: "10%",
                              "font-size": "12px",
                              color: "#5C666F"
                            }
                          },
                          [_vm._v("Fecha de despacho")]
                        ),
                        _vm._v(" "),
                        _c("datepicker", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showCalendar,
                              expression: "showCalendar"
                            }
                          ],
                          staticStyle: { "padding-left": "8px" },
                          attrs: {
                            "wrapper-class": "wc-mobile",
                            "input-class": "datepicker-ic-mobile",
                            disabledDates: _vm.disabledDates,
                            language: _vm.es
                          },
                          model: {
                            value: _vm.calendario,
                            callback: function($$v) {
                              _vm.calendario = $$v
                            },
                            expression: "calendario"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showSucursal,
                                expression: "showSucursal"
                              }
                            ],
                            staticClass: "fh lc",
                            staticStyle: {
                              "margin-left": "5%",
                              height: "10%",
                              "font-size": "12px",
                              color: "#5C666F"
                            }
                          },
                          [_vm._v("Sucursal de entrega")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sucursal,
                                expression: "sucursal"
                              },
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showSucursal,
                                expression: "showSucursal"
                              }
                            ],
                            staticClass: "wc-mobile",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.sucursal = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.sucursales, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option } },
                              [_vm._v(_vm._s(option.Nombre))]
                            )
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showEmail,
                                expression: "showEmail"
                              }
                            ],
                            staticClass: "fh lc",
                            staticStyle: {
                              "margin-left": "5%",
                              height: "10%",
                              "font-size": "12px",
                              color: "#5C666F"
                            }
                          },
                          [_vm._v("Email para envíar el Pedido en PDF")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showEmail,
                              expression: "showEmail"
                            }
                          ],
                          staticStyle: {
                            "text-align": "left",
                            "padding-left": "10px",
                            "margin-left": "5%",
                            "margin-bottom": "10px",
                            width: "88%",
                            height: "30px",
                            "font-size": "14px",
                            "border-radius": "5px",
                            "border-style": "solid",
                            color: "black"
                          },
                          attrs: { type: "email" },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "fh lc",
                            staticStyle: {
                              "margin-left": "5%",
                              height: "10%",
                              "font-size": "12px",
                              color: "#5C666F"
                            }
                          },
                          [_vm._v("Observaciones")]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.observaciones,
                              expression: "observaciones"
                            }
                          ],
                          staticStyle: {
                            resize: "none",
                            width: "85%",
                            "margin-left": "5%",
                            padding: "10px",
                            "border-radius": "5px",
                            height: "90px",
                            "border-style": "solid",
                            "border-width": "1px",
                            "border-color": "#dddddd",
                            "font-family": "'Rubik', sans-serif"
                          },
                          domProps: { value: _vm.observaciones },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.observaciones = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { attrs: { id: "btnContainerPopup" } }, [
                          _c(
                            "button",
                            {
                              attrs: { id: "btnclose" },
                              on: { click: _vm.btnCerrarPopup }
                            },
                            [_vm._v("CANCELAR")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              attrs: { id: "btnsend" },
                              on: { click: _vm.btnEnviarPopup }
                            },
                            [_vm._v("ENVIAR")]
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "fv lc", staticStyle: { width: "700px", height: "10vh" } },
      [_c("span", { attrs: { id: "label" } }, [_vm._v("Carrito de Compras")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1983740e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1983740e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/pedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1983740e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pedido/pedido.vue
// module chunks = 0